import React from "react";
import { styled } from "@mui/system";
import MUIAccordion from "@mui/material/Accordion";
import { AccordionProps as AccordionPropsMUI } from "@mui/material/Accordion";
export interface ExtendedAccordionProps extends AccordionPropsMUI {}

declare module "@mui/material/Paper" {
  interface PaperPropsVariantOverrides {
    error: true;
  }
}

const ExtendedAccordionRoot = styled(
  React.forwardRef<HTMLDivElement, ExtendedAccordionProps>((props, ref) => {
    return <MUIAccordion ref={ref} {...props} />;
  }),
  {
    name: "ExtendedAccordion",
    slot: "Root",
    overridesResolver: (props, styles) => []
  }
)(({ theme }) => ({
  "&.MuiAccordion-root": {
    marginTop: 0,
    marginBottom: 0
  }
}));

export const ExtendedAccordion = React.forwardRef<
  HTMLDivElement,
  ExtendedAccordionProps
>(function ExtendedAccordion(props, ref) {
  return <ExtendedAccordionRoot {...props} ref={ref} />;
}) as React.FC<ExtendedAccordionProps>;
